/**
 * Текст ошибки для тоста.
 *
 * Порядок: русская причина от сервера (`response.data.error.message`) →
 * русское сообщение локальной проверки (`new Error('Партномер не может быть
 * пустым')`) → запасной понятный текст. Англоязычные тексты axios и браузера
 * («Request failed with status code 422», «Network Error») пользователю не
 * показываем — вместо них уходит `fallback`.
 */
export function apiErrorText(err: unknown, fallback: string): string {
  const serverMessage = (err as { response?: { data?: { error?: { message?: string } } } })
    ?.response?.data?.error?.message
  if (serverMessage) return serverMessage
  if (err instanceof Error && /[А-Яа-яЁё]/.test(err.message)) return err.message
  return fallback
}
